(function () {
  'use strict';

  function initialiseProductRow(row) {
    if (!row || row.dataset.aaReady === 'true') return;

    var track = row.querySelector('[data-aa-mega-track]');
    var items = track ? Array.prototype.slice.call(track.children) : [];
    var previous = row.querySelector('[data-aa-mega-prev]');
    var next = row.querySelector('[data-aa-mega-next]');
    var pageLabel = row.querySelector('[data-aa-mega-page]');
    var currentPage = 0;
    var perPage = 6;

    if (!track || !items.length) return;

    function totalPages() {
      return Math.max(1, Math.ceil(items.length / perPage));
    }

    function update() {
      var pages = totalPages();
      currentPage = Math.min(currentPage, pages - 1);
      var viewport = track.parentElement;
      track.style.transform = 'translate3d(' + (-currentPage * viewport.clientWidth) + 'px,0,0)';
      pageLabel.textContent = (currentPage + 1) + ' / ' + pages;
      previous.disabled = currentPage === 0;
      next.disabled = currentPage >= pages - 1;
    }

    previous.addEventListener('click', function () {
      if (currentPage > 0) currentPage -= 1;
      update();
    });

    next.addEventListener('click', function () {
      if (currentPage < totalPages() - 1) currentPage += 1;
      update();
    });

    window.addEventListener('resize', update);
    row.dataset.aaReady = 'true';
    update();
  }

  function initialise() {
    if (window.innerWidth >= 991) {
      document.querySelectorAll('[data-aa-mega-products]').forEach(initialiseProductRow);
    }

    document.querySelectorAll('[data-aa-desktop-open]').forEach(function (item) {
      if (window.innerWidth >= 991) {
        if (!item.open) {
          item.open = true;
          item.dataset.aaAutoOpened = 'true';
        }

        item.classList.remove('is-closing');
        item.classList.add('is-open');

        var panel = item.querySelector('.cc-accordion-item__panel');
        if (panel) panel.style.removeProperty('height');
      } else if (item.dataset.aaAutoOpened === 'true') {
        item.open = false;
        item.classList.remove('is-open', 'is-closing');

        var mobilePanel = item.querySelector('.cc-accordion-item__panel');
        if (mobilePanel) mobilePanel.style.removeProperty('height');

        delete item.dataset.aaAutoOpened;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', initialise);
  window.addEventListener('resize', initialise);
}());
